type DroppedFileDataTransferItem = Pick<DataTransferItem, 'kind'> &
  Partial<Pick<DataTransferItem, 'getAsFile'>>;

type DroppedFileDataTransfer = {
  files?: ArrayLike<File>;
  items?: ArrayLike<DroppedFileDataTransferItem>;
};

const iPadOsFallbackFiles = new WeakSet<File>();

export const shouldMaterializeIpadOsFallbackFile = (file: File): boolean =>
  iPadOsFallbackFiles.has(file);

export const getDroppedFiles = (
  dataTransfer: DroppedFileDataTransfer,
): File[] => {
  const fallbackFiles = Array.from(dataTransfer.files ?? []);
  const fileItems = Array.from(dataTransfer.items ?? []).filter(
    (item) => item.kind === 'file',
  );

  if (fileItems.length === 0) {
    return fallbackFiles;
  }

  // Some browsers only expose dropped files through `files`. Prefer the File
  // returned directly by each DataTransferItem when available, but fall back
  // to the corresponding FileList entry so a mixed drop never loses files.
  const itemFiles = fileItems
    .map((item, index) => {
      const itemFile = item.getAsFile?.();
      if (itemFile) {
        iPadOsFallbackFiles.add(itemFile);
      }
      return itemFile ?? fallbackFiles[index];
    })
    .filter((file): file is File => file != null);

  return [...itemFiles, ...fallbackFiles.slice(fileItems.length)];
};
